import React from 'react'
import useStateBackLink from 'hooks/useStateBackLink'
import { useHistory } from 'react-router'
import { NewAbsenceButton } from 'redesign/components/atoms/Buttons/new-absence-button'
import { DrawerHeaderWrapper } from 'redesign/components/molecules/drawer-header-wrapper'
import SideMenuHeader from 'redesign/components/organisms/headers/SideMenuHeader'
import SideMenuNestedHeader from 'redesign/components/organisms/headers/side-menu-nested-header'
import { SideMenuTaskListContent } from 'redesign/components/organisms/side-menu-task-list-content'
import routes from 'services/RoutesProvider/routes'
import Filters from '../../Filters'
import { SIDE_MENU_ROOT_ID } from '../../SideMenu/constants'
import type { MenuPageProps } from '../../SideMenu/types'
import { useShiftUpdates } from '../hooks/use-shift-updates'
import ShiftUpdateMenuOption from '../shift-update-menu-option'

const PersonalShiftUpdates: React.FC<MenuPageProps> = ({ onClose, setPage, isDrawer = false, t, onRefresh }) => {
  const { setBackLink } = useStateBackLink()
  const history = useHistory()
  const {
    displayNestedContent,
    initialFilters,
    backgroundColor,
    onTaskClick,
    configuration,
    configLoading,
    favurUuid,
    onGoBack,
    personalTitleKey,
  } = useShiftUpdates({
    isOffice: false,
  })

  const header = displayNestedContent ? (
    <SideMenuNestedHeader isDrawer={isDrawer} onClose={onClose} titleKey={personalTitleKey} onGoBack={onGoBack} />
  ) : (
    <SideMenuHeader
      isDrawer={isDrawer}
      onClose={onClose}
      setPage={setPage}
      titleKey={personalTitleKey}
      isLoading={configLoading}
    />
  )
  const content = displayNestedContent ? (
    <ShiftUpdateMenuOption favurUuid={favurUuid ?? ''} onRefresh={onRefresh} />
  ) : (
    <SideMenuTaskListContent
      initialFilters={initialFilters}
      onTaskClick={onTaskClick}
      isLoadingConfig={configLoading}
    />
  )
  const footer = isDrawer ? null : (
    <NewAbsenceButton
      t={t}
      onClick={() => {
        setBackLink(routes.shifts)
        history.push(routes.newAbsenceRequest)
      }}
    />
  )

  return (
    <DrawerHeaderWrapper
      header={header}
      backgroundColor={backgroundColor}
      isLoading={configLoading}
      configuration={configuration}
      providerName="personal_shift_update_list"
      footer={footer}
    >
      {content}
      <Filters rootId={SIDE_MENU_ROOT_ID} />
    </DrawerHeaderWrapper>
  )
}

export default PersonalShiftUpdates
